import { render, staticRenderFns } from "./wechatMalll.vue?vue&type=template&id=a87f3f70&scoped=true"
import script from "./wechatMalll.vue?vue&type=script&lang=js"
export * from "./wechatMalll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87f3f70",
  null
  
)

export default component.exports